<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between">
      <div>
        <div class="section-title">{{ $tc("role", 2) }}</div>
        <div class="section-subTitle my-2">{{ $t("role_dash_msg") }}</div>
      </div>
      <div>
        <b-button
          v-if="$can('create', 'Roles')"
          variant="default"
          to="add-role"
          class="btn-blue"
          >{{ $tc("add") }}</b-button
        >
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center my-3">
      <div>
        <div>
          <b-form-input
            v-debounce:300="getRolesList"
            v-model="searchValue"
            placeholder="Search..."
          ></b-form-input>
        </div>
      </div>
      <div class="d-flex"></div>
      <div class="d-flex align-items-center">
        <!-- <FilterByStatusDropdown /> -->
        <div class>
          <b-dropdown name="listview" id="listview" variant="outline-blue">
            <template v-slot:button-content>
              {{ $t("viewing") }}&nbsp;
              <strong>{{ selectedvalue }}</strong>
              &nbsp;Of&nbsp;
              <strong>{{ rows }}</strong>
            </template>
            <b-dropdown-item
              v-for="(list, listIndex) in viewingnumbers"
              :key="listIndex"
              @click="onDropDownChangeValue(list.name)"
              >{{ list.name }}</b-dropdown-item
            >
          </b-dropdown>
        </div>
      </div>
    </div>

    <table class="list-view-table" v-if="listView">
      <thead>
        <tr>
          <th>
            <img
              v-if="!isSort"
              @click="onSortValue('role_name', 'asc')"
              src="@/assets/img/icons/updown.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else-if="isSort && isAscending"
              @click="onSortValue('role_name', 'asc')"
              src="@/assets/img/icons/asc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            <img
              v-else
              @click="onSortValue('role_name', 'desc')"
              src="@/assets/img/icons/desc.svg"
              class="cursor-pointer"
              width="15px"
              height="20px"
            />
            {{ $tc("role", 1) }}
          </th>
          <th class="text-right">
            <span class="pr-3">{{ $tc("status", 2) }}</span>
          </th>
        </tr>
      </thead>
      <tbody v-if="Roles.length > 0">
        <tr v-for="(item, key) in Roles" :key="key">
          <td>{{ $tc(item.role_name, 1) }}</td>
          <td>
            <div class="d-flex align-items-center justify-content-end">
              <!-- <label class="ios-switch">
                <input v-model="item.role_is_active" type="checkbox" class="ios-checkbox" disabled />
                <span class="switch-slider"></span>
              </label> -->
              <StatusDot
                :status="item.role_is_active ? 'active' : 'inactive'"
              />

              <!-- v-if="
                    //item.role_id != 1
                    // &&
                    //   item.role_id != 2 &&
                    //   item.role_id != 3 &&
                    //   item.role_id != 4 &&
                    //   item.role_id != 5 &&
                    //   item.role_id != 6 &&
                    //   item.role_id != 7 &&
                    //   item.role_id != 8 &&
                    //   item.role_id != 9 &&
                    //   item.role_id != 10
                  " -->

              <b-dropdown right variant="edit" class="ml-4">
                <b-dropdown-item
                  v-if="$can('update', 'Roles')"
                  @click="goToRoute('/user-management/edit-role', item)"
                >
                  <span class="edit-pen mr-1"></span>
                  {{ $t("edit") }}
                </b-dropdown-item>
                <b-dropdown-item
                  @click="goToRoute('/user-management/view-role', item)"
                >
                  <span class="icon-eye mr-1"></span>
                  {{ $t("view") }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-if="Roles.length == 0">
        <td>{{ customErrors.message }}</td>
      </tbody>
    </table>
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      @change="onChangePagination($event)"
      :per-page="perPage"
      aria-controls="my-table"
    ></b-pagination>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import Roles from "@/helper/formJSONMaster/Roles";
import StatusDot from "@/components/Partials/StatusDot.vue";
import FilterByStatusDropdown from "@/components/Partials/FilterByStatusDropdown.vue";
export default {
  components: {
    StatusDot,
    FilterByStatusDropdown,
  },
  data() {
    return {
      searchValue: "",
      perPage: 10,
      currentPage: 1,
      rows: 0,
      selectedvalue: "10",

      gridView: false,
      listView: true,
      Methods: Roles.Methods,
      Roles: [],
      viewingnumbers: [],
      customErrors: {
        message: "",
      },

      //Sortinh data
      isSort: false,
      isAscending: true,
      orderBy: "",
      columnName: "",
    };
  },
  beforeMount() {
    this.getRolesList();
    this.getviewingnumber();
  },
  mounted() {
    this.getRolesList();
  },

  methods: {
    getviewingnumber() {
      this.viewingnumbers = [
        { name: "All", id: 1 },
        { name: "10", id: 2 },
        { name: "20", id: 3 },
        { name: "30", id: 3 },
        { name: "40", id: 4 },
        { name: "50", id: 5 },
      ];
    },
    onDropDownChangeValue(event) {
      if (event == "All") {
        this.perPage = this.rows;
        this.selectedvalue = event;
        this.onChangePagination();
      } else {
        console.log("Numbers :", event);
        this.selectedvalue = event;
        this.perPage = event;
        console.log("perPage :", this.perPage);
        this.onChangePagination();
      }
    },
    /* eslint-disable */
    onChangePagination: function (event) {
      // console.log(event);
      if (event === undefined) {
        this.currentPage = 1;
        this.getRolesList();
      } else {
        this.currentPage = event;
        this.getRolesList();
      }
    },
    //Sort
    onSortValue(columnName, orderBy) {
      this.isSort = true;
      this.isAscending = !this.isAscending;
      this.columnName = columnName;
      this.orderBy = orderBy;
      this.getRolesList();
    },

    /* eslint-disable */
    goToRoute: function (path, item) {
      console.log("item :", item);
      const { role_id } = item;
      this.$router.push({
        path: path,
        query: {
          id: role_id,
        },
      });
    },
    getRolesList: function () {
      this.Roles = [];
      let body = this.getRequestBody("GET", undefined, this.Methods);
      body.url += `?searchKey=role_name&limit=${this.perPage}&currentPage=${this.currentPage}&searchValue=${this.searchValue}&orderBy=${this.orderBy}&columnName=${this.columnName}`;
      console.log("body :", body);
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            if (data.Records.length > 0) {
              // data.Records = data.Records.filter((x, i) => {
              //   if (
              // x.role_id != 1 &&
              // x.role_id != 2 &&
              // x.role_id != 3 &&
              // x.role_id != 4 &&
              // x.role_id != 5 &&
              // x.role_id != 6 &&
              // x.role_id != 7 &&
              // x.role_id != 8 &&
              // x.role_id != 9 &&
              // x.role_id != 10
              //   ) {
              //     return x;
              //   }
              // });
              // this.Roles = _.orderBy(data.Records, "role_id");
              // console.log("this.Roles :", this.Roles);
              this.Roles = data.Records;
              if (data.totalRows >= 10) {
                this.rows = data.totalRows;
              } else {
                this.rows = data.totalRows;
                this.selectedvalue = data.totalRows;
              }
            } else {
              this.customErrors.message = data.message;
            }
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },

    viewType: function (viewType) {
      if (viewType == "gridView") {
        this.gridView = true;
        this.listView = false;
      } else if ((viewType = "listView")) {
        this.listView = true;
        this.gridView = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/RolesComponentsOld/roles.vue